import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TinvPharmacySaleItemService {
  tinvPharmacySaleItem: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'tinv_pharmacy_sale_item/list/?';
  private AddRecord = webapi + 'tinv_pharmacy_sale_item/create';
  private EditRecord = webapi + 'tinv_pharmacy_sale_item/update';
  private GetRecord = webapi + 'tinv_pharmacy_sale_item/byid/';
  private ListByPatentid = webapi + 'tinv_pharmacy_sale_item/listbypatentid/';
  private ListbypatentidSearchItem = webapi + 'tinv_pharmacy_sale_item/listbypatentidSearchItem/';
  private ListDruge = webapi + 'tinv_pharmacy_sale_item/drugelist/';
  private DrugelistItemSearch = webapi + 'tinv_pharmacy_sale_item/drugelistItemSearch/';
  private DeleteRecord = webapi + 'tinv_pharmacy_sale_item/delete/';
  private UpdateDelivery = webapi + 'tinv_pharmacy_sale_item/deliverdruge/';
  private pharmacyitemByIdUrl = webapi + 'tinv_pharmacy_sale_item/getPharmacyItemsByAdmisionId/?';
  private exportUrl = webapi + 'tinv_pharmacy_sale_item/export';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    listByPatentid(patientId: any, pharmacyType: any) {
    return this.http.get(this.ListByPatentid + patientId + '/'+ pharmacyType)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    listbypatentidSearchItem(patientId: any, pharmacyType: any, key: any) {
    return this.http.get(this.ListbypatentidSearchItem + patientId + '/'+ pharmacyType+'/'+key)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getDrugeListService(id: any) {
    return this.http.get(this.ListDruge + id).toPromise().then(response => response.json()).catch(this.handleError);
  }
    drugelistItemSearch(id: any, key:any) {
    return this.http.get(this.DrugelistItemSearch + id + '/' + key).toPromise().then(response => response.json()).catch(this.handleError);
  }

  getUpdateDrugeDelivery(id: any) {
    return this.http.get(this.UpdateDelivery + id).toPromise().then(response => response.json()).catch(this.handleError);
  }

  //Use service by Jay for billing
  getPharmacyItemByAddmisionId(admisionId: any): Promise<any> {
    return this.http.get(this.pharmacyitemByIdUrl + 'admisionId=' + admisionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  exportRecordService(psId: any): Promise<any> {
    return this.http.get(this.exportUrl + '?psId=' + psId, { headers: this.headers })
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
}

}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/inventory/tinv-pharmacy-sale-item/tinv-pharmacy-sale-item.service.ts